export default "__VITE_ASSET__cBtlz38U__"